import { Route, Routes } from 'react-router-dom';
import { Overview } from 'views/Overview/Overview';
import { PcoTabNames } from 'reducers/shownPageReducer';
import { NotFound } from 'views/NotFound/NotFound';
import { Accounts } from 'views/Accounts/Accounts';
import { AccountShownPageType } from 'types';
import { SearchAccount } from 'views/Accounts/SearchAccount';
import { CaseUpdate } from 'views/Case/CaseUpdate';
import { PrivateBankingOverview } from './views/PrivateBanking/PrivateBankingOverview';
import { MockPage } from 'components/portfolio/MockPage';
import PortfolioSummary from 'views/PortfolioSummary/PortfolioSummary';
import { CountryRiskWaivers } from 'views/CountryRiskWaivers/CountryRiskWaivers';

const RouteList = () => {
  return (
    <Routes>
      <Route path="/partner" element={<Overview shownPage={''} />} />
      <Route path="/partner/:partnerId" element={<Overview shownPage={''} />} />
      <Route
        path="/partner/:partnerId/new/memberCode"
        element={<Overview shownPage={PcoTabNames.CreateMemberCode} />}
      />
      <Route path="/partner/:partnerId/memberCode" element={<Overview shownPage={PcoTabNames.OverviewMemberCode} />} />
      <Route path="/partner/:partnerId/case/:productId" element={<Overview shownPage={PcoTabNames.Case} />} />
      <Route
        path="/partner/:partnerId/videoIdentification"
        element={<Overview shownPage={PcoTabNames.VideoIdentificationForm} />}
      />
      <Route
        path="/partner/:partnerId/videoIdentification/:productId"
        element={<Overview shownPage={PcoTabNames.VideoIdentification} />}
      />
      <Route
        path="/partner/:partnerId/subscriptionManagment"
        element={<Overview shownPage={PcoTabNames.SubscriptionManagement} />}
      />
      <Route path="/partner/:partnerId/new/mandate" element={<Overview shownPage={PcoTabNames.NewMandate} />} />
      <Route
        path="/partner/:partnerId/addProductOrService"
        element={<Overview shownPage={PcoTabNames.AddProductOrService} />}
      />
      <Route
        path="/partner/:partnerId/product/addProductOrService"
        element={<Overview shownPage={PcoTabNames.AddProductOrService} />}
      />
      <Route
        path="/partner/:partnerId/product/addProductOrService/serviceAgreement/:processInstanceId/configuration"
        element={<Overview shownPage={PcoTabNames.ProductConfiguration} />}
      />
      <Route
        path="/partner/:partnerId/serviceAgreement/modification"
        element={<Accounts shownPage={AccountShownPageType.PRODUCT_MODIFICATION} />}
      />
      <Route
        path="/partner/:partnerId/product/addProductOrService/serviceAgreement/:processInstanceId/details"
        element={<Overview shownPage={PcoTabNames.ProductDetails} />}
      />
      <Route
        path="/partner/:partnerId/serviceAgreement/:processInstanceId/configuration"
        element={<Overview shownPage={PcoTabNames.ProductConfiguration} />}
      />
      <Route
        path="/partner/:partnerId/serviceAgreement/:processInstanceId/details"
        element={<Overview shownPage={PcoTabNames.ProductDetails} />}
      />
      <Route path="/partner/:id/case/:caseId/update" element={<CaseUpdate location={'partner'} />} />
      <Route path="/accounts" element={<Accounts />} />
      <Route path="/accounts/search" element={<SearchAccount />} />
      <Route path="/accounts/:brUid" element={<Accounts />} />
      <Route
        path="/accounts/:brUid/addProductOrService"
        element={<Accounts shownPage={AccountShownPageType.ORDER_NEW_PRODUCT_OR_SERVICE} />}
      />
      <Route
        path="/accounts/:brUid/serviceAgreement/:processInstanceId/configuration"
        element={<Accounts shownPage={AccountShownPageType.PRODUCT_CONFIGURATION} />}
      />
      <Route
        path="/accounts/:brUid/serviceAgreement/modification"
        element={<Accounts shownPage={AccountShownPageType.PRODUCT_MODIFICATION} />}
      />
      <Route
        path="/accounts/:brUid/serviceAgreement/:serviceAgreementUid/details"
        element={<Accounts shownPage={AccountShownPageType.PRODUCT_DETAILS} />}
      />
      <Route
        path="/accounts/:brUid/serviceAgreement/:serviceAgreementUid/details/:taskId"
        element={<Accounts shownPage={AccountShownPageType.PRODUCT_DETAILS} />}
      />
      <Route
        path="/accounts/:brUid/serviceAgreement/:serviceAgreementUid/details/serviceRole/:serviceRoleUid/details"
        element={<Accounts shownPage={AccountShownPageType.SERVICE_ROLE} />}
      />
      <Route path="/accounts/:id/case/:caseId/update" element={<CaseUpdate location={'accounts'} />} />
      <Route
        path="/accounts/:accountIdFromParam/case/:productIdFromParam"
        element={<Accounts shownPage={AccountShownPageType.CASE} />}
      />
      <Route
        path="/accounts/:accountIdFromParam/product/:productIdFromParam"
        element={<Accounts shownPage={AccountShownPageType.PRODUCT} />}
      />
      <Route
        path="/accounts/:accountIdFromParam/product/:productIdFromParam/change"
        element={<Accounts shownPage={AccountShownPageType.CHANGE_MANDATE} />}
      />
      <Route
        path="/accounts/:accountIdFromParam/new/mandate"
        element={<Accounts shownPage={AccountShownPageType.NEW_MANDATE} />}
      />
      <Route path="/private-banking" element={<PrivateBankingOverview />} />
      <Route path="/private-banking/:brUuid/country-risk-waivers" element={<CountryRiskWaivers />} />
      <Route path="/private-banking/:brUuid/" element={<PrivateBankingOverview />} />
      <Route path="/add-portfolio-dialog" element={<MockPage />} />
      <Route path="/portfolio-summary/:brUid" element={<PortfolioSummary />} />
      <Route element={<NotFound />} />
    </Routes>
  );
};

export { RouteList };
